import React, { useRef, useState } from "react";
import classnames from "classnames";
import ReactTooltip from "react-tooltip";
import OutsideClickHandler from "react-outside-click-handler";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import "./DropdownShadow.styles.scss";
import { IStatus } from "../../../store/types/deal";
import { useDealParamsHooks } from "../../../hooks/deal-hooks/use-deal-params-hooks";
import { useRoleGuardHook } from "hooks";
import { RoleName } from "../../../constants";
import { DealRoleGuard } from "components/guards";
import { CurrencyType } from "store/types";

export interface DropdownShadowProps {
  className?: string;
  statuses: IStatus[] | CurrencyType[];
  status: IStatus | CurrencyType;
  onChange: (...args: any) => void;
}

export const DropdownShadow: React.FC<DropdownShadowProps> = ({ className = "", statuses, status, onChange }) => {
  const { dealId } = useDealParamsHooks();

  const [isActive, setIsActive] = useState<boolean>(false);

  const setIsActiveWithRoles = useRoleGuardHook(() => setIsActive(!isActive), [RoleName.Admin, RoleName.Analyst]);

  const refToText: React.RefObject<HTMLSpanElement> = useRef(null);

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setIsActive(false);
      }}
    >
      <div className={classnames("deal-status", { [className]: !!className })}>
        <div
          data-tip={
            refToText?.current?.scrollWidth! > refToText?.current?.clientWidth!
              ? typeof status !== "string"
                ? status?.name
                : status
              : ""
          }
          onClick={setIsActiveWithRoles}
          className={`deal-status__head flex-row-sb-fc scale-click ${
            typeof status !== "string" && status?.id === 4 && status?.name === "Invested"
              ? "deal-status__head-green__status"
              : null
          }`}
        >
          <span ref={refToText} className="one-row-text">
            {typeof status !== "string" ? status?.name : status}
          </span>
          <DealRoleGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
            <ArrowDropDownIcon className={`rotate-180 rotate-180${isActive ? "--active" : ""}`} fill="#839DA9" />
          </DealRoleGuard>
          <ReactTooltip delayShow={250} className="tooltip" place="top" effect="solid" type="light" />
        </div>
        <div
          className={`
            deal-status__body
            opacity-render
            opacity-render${isActive ? "--active" : ""}
            ${isActive ? "deal-status__active" : "deal-status__inactive"}
            `}
        >
          <div className="deal-status__list-wrap flex-col-fs-fs">
            <div className="deal-status__list flex-col-fs-st">
              {(statuses as any).map((element: any, index: number) => {
                return (
                  <div
                    key={index}
                    onClick={() => {
                      if (typeof status !== "string" && typeof element !== "string") {
                        if (element.id !== status.id) {
                          if (dealId) {
                            onChange(dealId, element);
                          }
                        }
                      }
                      onChange(element);
                      setIsActive(false);
                    }}
                    className="deal-status__list-item scale-click"
                  >
                    {typeof element !== "string" ? element.name : element}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </OutsideClickHandler>
  );
};
